import { createAction } from '@reduxjs/toolkit';

import { GA_COMPONENT_UNKNOWN_COMPONENT_VALUE } from '~shared/utils/google-analytics';

export const initialSelectionData = {
    stake: 0,
    each_way_selected: false,
    free_bet_id: null,
    sp_selected: false,
    is_scorecast: false,
    is_cast_market: false,
    is_any: false,
    survey_id: null,
    recommended: false,
    recommendation_location: '',
    original_price: undefined,
    bet_locate: GA_COMPONENT_UNKNOWN_COMPONENT_VALUE,
};

export const initialState = [];

export const addSelection = createAction(
    'betslip/userSelections/addSelection',
    selection => ({
        payload: {
            ...initialSelectionData,
            ...selection,
        },
    }),
);

export const ACTION_STRING_CLEAR_SELECTIONS = 'betslip/userSelections/clearSelections';
export const ACTION_STRING_REMOVE_SELECTION = 'betslip/userSelections/removeSelection';

export const clearSelections = createAction(ACTION_STRING_CLEAR_SELECTIONS);
export const removeSelection = createAction(ACTION_STRING_REMOVE_SELECTION);
export const updateAllSelections = createAction('betslip/userSelections/updateAllSelections');
export const updateSelection = createAction('betslip/userSelections/updateSelection');
export const clearPricesByCombinationType = createAction('betslip/userSelections/clearPricesByCombinationType');
